import { RuleObject } from 'antd/lib/form';
import React from 'react';

import TranslateText from 'components/hoc/TranslateText';

const modulo11ADI = (str: String) => {
    const kmod11adi = [4, 3, 2, 7, 6, 5, 4, 3, 2];
    let comp = 0;
    for (let i = 0; i < 9; i++) comp += (str.charAt(i).charCodeAt(0) - '0'.charCodeAt(0)) * kmod11adi[i];
    const k = (11 - (comp % 11)) % 10;
    return str.charAt(9).charCodeAt(0) - '0'.charCodeAt(0) != k;
};

const badModulo11ADI009 = [
    '0092496185',
    '0093017922',
    '0093018243',
    '0093022847',
    '0095527403',
    '0095771978',
    '0099414789',
    '0099988909'
];

const badModulo11ADI999 = ['9990054746', '9990071421'];

// Kontrola NID (Nahradni identifikacni cislo)
// Napriklad: 0090038923,8880007247,9990099178
// 0 - OK
// 1 - E: nezadano
// 2 - E: chybna syntaxe
// 3 - E: chybna kontrolka
// 6 - E: pseudo RC nepodporovano
export const validateNID = (str: string) => {
    if (str === null || str === '') return 1; // nezadano

    if (!/^[0-9]{10}$/.test(str)) return 2; // chybna syntaxe

    const numNID = parseInt(str.substring(3, 9));
    if (str.startsWith('009')) {
        // pro nektera cisla pro pravnicke osoby
        // nemusi byt spravna kontrolka pro kontrolu modulo11ADI
        if (numNID <= 772) return 0;

        if (badModulo11ADI009.includes(str))
            // vyjimky
            return 0;

        if (modulo11ADI(str)) return 3; // chybna kontrolka
        return 0;
    }

    if (str.startsWith('999')) {
        if (badModulo11ADI999.includes(str))
            // vyjimky
            return 0;

        if (modulo11ADI(str)) return 3; // chybna kontrolka
        return 0;
    }

    if (modulo11ADI(str)) return 3; // chybna kontrolka

    if (str.startsWith('888')) {
        // NID generovany v SCP (tj. neni z CP)
        return 0;
    }
    return 6; // nepodporovano
};

export const nidValidation = () => [
    () => ({
        validator(_rule: RuleObject, value: string) {
            if (!value || validateNID(value) === 0) return Promise.resolve();
            return Promise.reject(<TranslateText>CHYBNY_NID</TranslateText>);
        }
    })
];

export default nidValidation;
